// src/components/pages/shared/LocationDialog.tsx

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { DLG_BTN_PRIMARY, DLG_BTN_SECONDARY } from '@/components/ui/dialogButtons';

interface LocationDialogProps {
  open: boolean;
  onAllow: () => void;
  onReject: () => void;
}

const LocationDialog = ({ open, onAllow, onReject }: LocationDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="
          z-[60] p-0 border border-gray-200 dark:border-white/10 bg-white dark:bg-[#1c1c1e]
          [&>button:last-child]:hidden
          flex flex-col
          !bottom-0 !left-0 !top-auto !translate-x-0 !translate-y-0
          w-full max-w-none max-h-[85vh] rounded-t-2xl rounded-b-none
          data-[state=open]:slide-in-from-bottom data-[state=closed]:slide-out-to-bottom
          data-[state=open]:duration-300 data-[state=closed]:duration-200
          sm:!bottom-auto sm:!left-1/2 sm:!top-1/2 sm:!-translate-x-1/2 sm:!-translate-y-1/2
          sm:w-[95%] sm:max-w-sm sm:mx-auto sm:h-auto sm:max-h-[85vh] sm:rounded-xl sm:shadow-xl
          text-center p-6 sm:p-8
        "
      >
        <DialogHeader>
          <DialogTitle className="text-base sm:text-lg font-semibold text-[#103254] dark:text-white">
            ¿Deseas compartir tu ubicación?
          </DialogTitle>

          <DialogDescription className="text-gray-600 dark:text-gray-400 mt-2 text-sm sm:text-base leading-relaxed">
            Usaremos tu ubicación para mostrarte empresas más cercanas a ti.
            <br />
            <span className="text-xs sm:text-sm text-gray-400 dark:text-gray-500">
              No almacenamos tu localización ni la compartimos con terceros.
            </span>
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="mt-6 border-t border-gray-200/70 dark:border-white/10 pt-4 flex flex-col sm:flex-row gap-3">
          <Button variant="outline" onClick={onReject} className={DLG_BTN_SECONDARY}>
            No, gracias
          </Button>
          <Button onClick={onAllow} className={DLG_BTN_PRIMARY}>
            Sí, compartir
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LocationDialog;